var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.894,
    height: 6.406,
    viewBox: "0 0 12.894 6.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13971",
    "data-name": "Path 13971",
    d: "M0,0,2.895,3.2,0,6.406H2.575L5.468,3.2,2.575,0Z",
    fill: "#f27a43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13972",
    "data-name": "Path 13972",
    d: "M40.554,0l2.894,3.2-2.894,3.2h2.574l2.894-3.2L43.128,0Z",
    transform: "translate(-36.84)",
    fill: "#f27a43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13973",
    "data-name": "Path 13973",
    d: "M81.107,0,84,3.2l-2.894,3.2h2.574l2.894-3.2L83.681,0Z",
    transform: "translate(-73.68)",
    fill: "#f27a43"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.c561b8588ee6aaf463f50157d83df962.svg";
export { ForwardRef as ReactComponent };